import { createContext } from "react";

const ForgotPasswordContext = createContext();

export default ForgotPasswordContext;
